import { useTranslate } from "src/i18n";

import { Review } from "../types/review.ts";

export const useReviews = (): Review[][] => {
  const { t } = useTranslate();
  return [
    [
      {
        name: t("landing.reviews_block.cards.card_1.name", "Егор С."),
        description: t(
          "landing.reviews_block.cards.card_1.description",
          "Разработчик ботов",
        ),
        text: t(
          "landing.reviews_block.cards.card_1.text",
          "Система огонь! Уже шестой проект на ней делаю!",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_2.name", "Андрей K."),
        description: t(
          "landing.reviews_block.cards.card_2.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_2.text",
          "Лучшая платформа для ИМ из тех, что я видел",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_3.name", "Алексей У."),
        description: t(
          "landing.reviews_block.cards.card_3.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_3.text",
          "Доволен платформой. У меня удобный и функциональный магазин!",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_4.name", "Максим Г."),
        description: t(
          "landing.reviews_block.cards.card_4.description",
          "Разработчик",
        ),
        text: t(
          "landing.reviews_block.cards.card_4.text",
          "Очень хорошее API. Работает без сбоев",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_5.name", "Игорь Б."),
        description: t(
          "landing.reviews_block.cards.card_5.description",
          "Логист",
        ),
        text: t(
          "landing.reviews_block.cards.card_5.text",
          "Ребята знают свою работу на 5+. Рекомендую!",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_6.name", "Павел А."),
        description: t(
          "landing.reviews_block.cards.card_6.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_6.text",
          "Разработки платформы помогли автоматизировать прием заказов",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_7.name", "Анастасия Д."),
        description: t(
          "landing.reviews_block.cards.card_7.description",
          "Логист",
        ),
        text: t(
          "landing.reviews_block.cards.card_7.text",
          "Думала, что будет сложно разобраться. В итоге за час настроила все что нужно",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_8.name", "Виталий А."),
        description: t(
          "landing.reviews_block.cards.card_8.description",
          "Разработчик ботов",
        ),
        text: t(
          "landing.reviews_block.cards.card_8.text",
          "Крутая платформа, получение цен по API, выгрузка товаров за приятную цену.",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_9.name", "Анатолий К."),
        description: t(
          "landing.reviews_block.cards.card_9.description",
          "Байер",
        ),
        text: t(
          "landing.reviews_block.cards.card_9.text",
          "Круто! Очень круто! У ребят есть функция выгрузки товаров. Перестал пользоваться апи",
        ),
      },
    ],
    [
      {
        name: t("landing.reviews_block.cards.card_10.name", "Илья Р."),
        description: t(
          "landing.reviews_block.cards.card_10.description",
          "Байер",
        ),
        text: t(
          "landing.reviews_block.cards.card_10.text",
          "Отличный сайт для заказа и отслеживания товаров. Все понятно и просто",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_11.name", "Роман К."),
        description: t(
          "landing.reviews_block.cards.card_11.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_11.text",
          "Пользуюсь давно. Нравится сервис и возможности которые он предоставляет",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_12.name", "Анна Д."),
        description: t(
          "landing.reviews_block.cards.card_12.description",
          "Логист",
        ),
        text: t(
          "landing.reviews_block.cards.card_12.text",
          "На сегодняшний день не вижу для себя альтернатив",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_13.name", "Владимир Л."),
        description: t(
          "landing.reviews_block.cards.card_13.description",
          "Разработчик",
        ),
        text: t(
          "landing.reviews_block.cards.card_13.text",
          "Все отлично работает, отличная поддержка, качественный сервис",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_14.name", "Дмитрий О."),
        description: t(
          "landing.reviews_block.cards.card_14.description",
          "Логист",
        ),
        text: t(
          "landing.reviews_block.cards.card_14.text",
          "Удобная платформа, адекватные цены, оперативная поддержка!",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_15.name", "Григорий П."),
        description: t(
          "landing.reviews_block.cards.card_15.description",
          "Байер",
        ),
        text: t(
          "landing.reviews_block.cards.card_15.text",
          "За вечер сделали выгрузку около 100тыс товаров. Планирую открывать магазин",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_16.name", "Никита М."),
        description: t(
          "landing.reviews_block.cards.card_16.description",
          "Разработчик",
        ),
        text: t(
          "landing.reviews_block.cards.card_16.text",
          "Боты пишутся на изи. Не нужно прописывать каждый запрос отдельно и настраивать типы",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_17.name", "Егор Ш."),
        description: t(
          "landing.reviews_block.cards.card_17.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_17.text",
          "Быстрая интеграция с другими сервисами по созданию магазина",
        ),
      },
      {
        name: t("landing.reviews_block.cards.card_18.name", "Кристина Х."),
        description: t(
          "landing.reviews_block.cards.card_18.description",
          "Владелец магазина",
        ),
        text: t(
          "landing.reviews_block.cards.card_18.text",
          "Это просто нечто! Созвонились с ребятами, они помогли все настроить для магазина.",
        ),
      },
    ],
  ];
};
